import { render } from "./DeviceDelete.vue?vue&type=template&id=1ddee6a8"
import script from "./DeviceDelete.vue?vue&type=script&lang=js"
export * from "./DeviceDelete.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__